
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/functions';
import 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyA0zADRHvaD3nyw_bicWLTneRWfHap4I-E",
    authDomain: "agents-crashstickers.firebaseapp.com",
    databaseURL: "https://agents-crashstickers.firebaseio.com",
    projectId: "agents-crashstickers",
    storageBucket: "agents-crashstickers.appspot.com",
    messagingSenderId: "294997908076",
    appId: "1:294997908076:web:58268570f3e7572f90d649"
};

firebase.initializeApp(firebaseConfig);

// firebase utils
const db = firebase.firestore();
const storage = firebase.storage();
const fnct = firebase.app().functions('europe-west1');
const fv = firebase.firestore.FieldValue;
const auth = firebase.auth();

// TODO: Check we need to export currentUser
const currentUser = auth.currentUser;

const settings = {
    cacheSizeBytes: firebase.CACHE_SIZE_UNLIMITED
};
db.settings(settings);

export { db, storage, fnct, fv, auth, currentUser };
